import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppMessageOfTheDay, AppSurveyEntity } from '@nk/data-entities-lib';
import { HttpParams } from '@angular/common/http';
import { AppContentEntity } from '@nk/data-entities-lib';
import { ApplicationApiClient } from '@nk/api-client-lib';
import { CachingService } from '@nk/caching-lib';

@Injectable()
export class AppContentService {
  constructor(
    private _api: ApplicationApiClient,
    private _cachingService: CachingService,
  ) {}

  public appContentByIdentifierCache = this._cachingService.create(this, this.fetchAppContentByIdentifier);
  public fetchAppContentByIdentifier(identifier: string): Observable<AppContentEntity> {
    return this._api.get<AppContentEntity>(`app-content/${identifier}`, {}, null);
  }

  public appContentMessageOfTheDayCache = this._cachingService.create(this, this.fetchAppContentMessageOfTheDay);
  public fetchAppContentMessageOfTheDay(identifier: string): Observable<AppMessageOfTheDay[]> {
    return this._api.get<AppMessageOfTheDay[]>(`app-customer/${identifier}/app-message-of-the-day`, {}, null);
  }

  public appSurveyCache = this._cachingService.create(this, this.fetchAppSurvey);
  public fetchAppSurvey(appMembershipUuid: string, languageCode: string): Observable<AppSurveyEntity[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('app_membership_uuid', appMembershipUuid);
    httpParams = httpParams.append('language_code', languageCode);
    return this._api.get<AppSurveyEntity[]>(
      `app-survey`,
      {
        params: httpParams,
      },
      null,
    );
  }
}
